import * as z from "zod/v4";

export const startBisImport = {
  name: "startBisImport" as const,
  input: z.object({ s3Key: z.string(), filename: z.string() }),
  output: z.object({ workflowId: z.string() }),
};
